import { ImageSeriesField } from "@/01-core/entity/entities/entityV2";
import { WorkflowEvent } from "../interface";

export interface InspirationSearchEvent {
  events: WorkflowEvent[];
  intermediate_outputs?: {
    video_count: number;
    video_total_gmv: number;
    normalized_video_total_gmv: number;
    video_play_count: number;
    video_popularity: number;
    retrieved_video_id_list: string[];
  };
  inputs: {
    keyword: string;
    create_time: number;
    field_filter_display_name: {
      zh: string[];
      en: string[];
    };
  };
}
export interface CommonItem {
  name: string;
  proof: string[];
  [InspirationField.VIDEO_COUNT]: number;
  [InspirationField.VIDEO_PLAY_COUNT]: number;
  [InspirationField.VIDEO_TOTAL_GPM]: number;
  [InspirationField.VIDEO_POPULARITY]: number;
  [InspirationField.VIDEO_TOTAL_GMV]: number;
  video_total_gmv: number;
  top_video_info_list: {
    video_id: string;
    video_desc: string;
    video_ai_description_zh: string;
    video_play_count: number;
    video_popularity: number;
    video_total_gmv: number;
    follower_count: number;
    author_unique_id: string;
    normalized_video_total_gmv: number;
    video_total_gpm: number;
    country_code: string;
    tags_zh: {
      picture_type: string[];
      mouth_sowing_type: string;
      content_presentation: string[];
      scene_type: string[];
      audience_age: string[];
      audience_gender: string;
      audience_hobby: string[];
      selling_point: string[];
      pain_point: string[];
      clip_content: string[];
    };
  }[];
}
export interface InspirationOutput {
  [InspirationType.SELLING_POINT]: CommonItem[];
  [InspirationType.PAIN_POINT]: CommonItem[];
  [InspirationType.CONTENT_PRESENTATION]: CommonItem[];
  [InspirationType.HASHTAG]: CommonItem[];
}

export enum InspirationType {
  SELLING_POINT = "selling_point",
  PAIN_POINT = "pain_point",
  CONTENT_PRESENTATION = "content_presentation",
  HASHTAG = "hash_tag",
}

export enum InspirationField {
  VIDEO_COUNT = "video_count",
  VIDEO_PLAY_COUNT = "video_play_count",
  VIDEO_TOTAL_GMV = "video_total_gmv",
  VIDEO_POPULARITY = "video_popularity",
  VIDEO_TOTAL_GPM = "video_total_gpm",
}

export interface InspirationKeywordExtension {
  brands: {
    word: string;
    video_count: number;
    l1_category?: string;
    l2_category?: string;
    l3_category?: string;
  }[];
  products: {
    word: string;
    video_count: number;
    image_series: ImageSeriesField["value"];
  }[];
  categories: {
    word: string;
    video_count: number;
  }[];
}

export enum InspirationKeywordType {
  BRAND = "brand",
  PRODUCT = "product",
  CATEGORY = "category",
}
